import React from 'react';
import { Box, Typography } from '@mui/material';

interface ContactInfoImageProps {
  language: 'en' | 'de';
}

export const ContactInfoImage: React.FC<ContactInfoImageProps> = ({ language }) => {

  return (
    <Box sx={{ textAlign: 'center', my: 2 }}>
      <Box
        sx={{
          maxWidth: '350px',
          mx: 'auto',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
        }}
        component="span"
        role="text"
        aria-label="contact information"
      >
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1.5 }}>
          {language === 'de' ? 'Kontaktinformationen' : 'Contact Information'}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            mb: 0.5,
            fontFamily: 'monospace',
            pointerEvents: 'none',
            '&::selection': {
              backgroundColor: 'transparent',
            },
            '&::-moz-selection': {
              backgroundColor: 'transparent',
            },
          }}
        >
          Rebecca Jussen
        </Typography>
        <Typography
          variant="body2"
          sx={{
            mb: 0.5,
            fontFamily: 'monospace',
            pointerEvents: 'none',
            '&::selection': {
              backgroundColor: 'transparent',
            },
            '&::-moz-selection': {
              backgroundColor: 'transparent',
            },
          }}
        >
        Georgenstraße 102
      </Typography>
        <Typography
          variant="body2"
          sx={{
            mb: 0.5,
            fontFamily: 'monospace',
            pointerEvents: 'none',
            '&::selection': {
              backgroundColor: 'transparent',
            },
            '&::-moz-selection': {
              backgroundColor: 'transparent',
            },
          }}
        >
        80798 München
        </Typography>
        <Typography
          variant="body2"
          sx={{
            mb: 0.5,
            fontFamily: 'monospace',
            pointerEvents: 'none',
            '&::selection': {
              backgroundColor: 'transparent',
            },
            '&::-moz-selection': {
              backgroundColor: 'transparent',
            },
          }}
        >
          Germany
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontFamily: 'monospace',
            color: 'primary.main',
            pointerEvents: 'none',
            '&::selection': {
              backgroundColor: 'transparent',
            },
            '&::-moz-selection': {
              backgroundColor: 'transparent',
            },
          }}
        >
          runforme.contact(at)gmail.com
        </Typography>
      </Box>
    </Box>
  );
};
